export function addAddressCheckout() {
  jQuery("#modalAddNewAddress .default-orange-button").on(
    "click",
    function (e) {
      e.preventDefault();
      const form = jQuery("#modalAddNewAddress form");
      const data = {
        action: "save_new_address",
        full_name: form.find('[name="full_name"]').val().trim(),
        phone: form.find('[name="phone"]').val().trim(),
        address_1: form.find('[name="address_1"]').val().trim(),
        address_2: form.find('[name="address_2"]').val().trim(),
        district: form.find('[name="district"]').val().trim(),
        state: form.find('[name="state"]').val().trim(),
        eircode: form.find('[name="eircode"]').val().trim(),
        city: form.find('[name="city"]').val().trim(),
        instructions: form.find('[name="instructions"]').val().trim(),
        make_default: form.find('[name="make_default"]').is(":checked") ? 1 : 0,
      };

      // limpar mensagens de erro
      jQuery("#modalAddNewAddress .error-message").remove();

      jQuery.post(
        my_ajax_object.ajax_url,
        data,
        function (resp) {
          if (resp.success) {
            // 1) fecha modal
            jQuery("#modalAddNewAddress").modal("hide");
            jQuery(".list-address-options").replaceWith(
              resp.data.addresses_html
            );

            alert(resp.data.message);
          } else {
            // exibe o erro dentro do modal
            jQuery(
              '<p class="error-message text-danger">' +
                resp.data.message +
                "</p>"
            ).insertAfter(jQuery("#modalAddNewAddress .modal-header"));
          }
        },
        "json"
      );
    }
  );
}
